export type MenuTheme = 'light' | 'dark' | 'realDark';

export type ContentWidth = 'Fluid' | 'Fixed';

export interface DefaultSettings {
  /**
   * theme for nav menu
   */
  navTheme: MenuTheme;
  /**
   * primary color of ant design
   */
  primaryColor: string;
  /**
   * nav menu position: `side`, `top`, or `mix`
   */
  layout: 'side' | 'top' | 'mix';
  /**
   * layout of content: `Fluid` or `Fixed`, only works when layout is topmenu
   */
  contentWidth: ContentWidth;
  /**
   * sticky header
   */
  fixedHeader: boolean;
  /**
   * auto hide header
   */
  autoHideHeader: boolean;
  /**
   * sticky siderbar
   */
  fixSiderbar: boolean;
  menu: { locale: boolean };
  title: string;
  pwa: boolean;
  // Your custom iconfont Symbol script Url
  // eg：//at.alicdn.com/t/font_1039637_btcrd5co4w.js
  // 注意：如果需要图标多色，Iconfont 图标项目里要进行批量去色处理
  // Usage: https://github.com/ant-design/ant-design-pro/pull/3517
  iconfontUrl: string;
  colorWeak: boolean;
}

export default {
  navTheme: 'light',
  primaryColor: '#1890FF',
  // pro-layout v7: 'mix' renders a top header (where rightContentRender / user info live)
  // AND a sider with all menu items (when splitMenus: false). This matches the v4
  // 'sidemenu' layout which had the same structure.
  layout: 'mix',
  contentWidth: 'Fluid',
  // fixedHeader: true ensures the header sits ABOVE the sider (not overlapped by it).
  // Without this, the sider starts from y=0 and its dark top section merges visually
  // with the logo area, making it look like the logo is embedded in the sider rather
  // than in a distinct top bar.
  fixedHeader: true,
  autoHideHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  // pro-layout v7: splitMenus moves top-level items into a header and only shows
  // their children in the sider. The app uses a single-level side menu, so this
  // must be false to render the full sidebar (v4 ignored it for the sidemenu layout).
  splitMenus: false,
  menu: {
    locale: true,
  },
  title: 'Atlas',
  pwa: false,
  iconfontUrl: '',
} as DefaultSettings;
